import classnames from "classnames";
import Link from "next/link";
import React, { FC } from "react";

import { SimpleDropdownOption } from "./SimpleDropdown";

type SimpleDropdownItemProps = {
  option: SimpleDropdownOption;
  close: () => void;
};

const SimpleDropdownItem: FC<SimpleDropdownItemProps> = ({ close, option }) => {
  const { href, label, onSelect, separator, value } = option;
  const onSelectAndClose = () => {
    if (onSelect) {
      onSelect(value);
    }
    close();
  };

  const classes = classnames("simple-dropdown-item", { separator });

  return (
    <div className={classes}>
      {href ? (
        href.startsWith("/") ? (
          <Link href={href}>
            <a onClick={onSelectAndClose}>{label}</a>
          </Link>
        ) : (
          <a onClick={onSelectAndClose} href={href}>
            {label}
          </a>
        )
      ) : (
        <a onClick={onSelectAndClose}>{label}</a>
      )}
    </div>
  );
};

export default SimpleDropdownItem;
